<template>
  <section class="column">
    <div class="flex-space-between user-search-title">
      <h3 class="title is-3">Add Users</h3>
    </div>
    <section class="user-search-container">

      <div class="field is-grouped">
        <p class="control is-expanded">
          <input
            class="input"
            type="search"
            name='search'
            placeholder="search"
            v-model="query">
        </p>
      </div>
      <ul v-if="!loading && searchResults.length > 0">
        <li class="flex-space-between panel-block" v-for="user in searchResults">
          {{ user.name || user.email }} <span v-if="user.is_coach" class="tag is-rounded is-primary">Coach</span><span v-if="user.is_group_admin" class="tag is-rounded is-warning">Admin</span>
          <input
            @click="addUser(team.id, user)"
            class='button is-small'
            type='button'
            value='add'
            name='add'/>
        </li>
      </ul>
      <p
        v-else-if="query !== ''"
        class="no-results">
        No results for query <strong>{{ query }}</strong>
      </p>
      <p v-else class="no-results">No users to add.</p>
    </section>
  </section>
</template>

<script>
import store from '../store.js'

export default {
  name: 'GroupUserSearch',
  props: {
    team: {
      type: Object,
      required: true,
    },
  },
  mounted () {
    store.dispatch('fetchGroup')
  },
  data () {
    return {
      query: '',
    }
  },
  computed: {
    loading () {
      return store.state.loadingGroup
    },
    groupUsers () {
      return store.state.group.users
    },
    searchResults () {
      // sometimes, groupUsers is null before we fetch the data
      if (this.groupUsers == null) return []
      // 1. ensure that user isn't already in team
      // 2. check that the user is relevant for the query
      return this.groupUsers
        .filter(x => this.team.members.find(m => m.id === x.id) == null)
        .filter(x =>
          x.email != null && x.email.toUpperCase().includes(this.query.toUpperCase()) ||
          x.name != null && x.name.toUpperCase().includes(this.query.toUpperCase())
        )
    },
  },
  methods: {
    addUser (teamID, user) {
      store.dispatch('addUserToTeam', { teamID, user })
      this.query = ''
    },
  },
}
</script>

<style lang="scss" scoped>

.user-search-title {
  margin-top: 1rem;
  margin-bottom: 0;
  & > h3 {
    margin-bottom: 0;
  }
}

.user-search-container {
  margin-top: 0.5rem;
}

.no-results {
  text-align: center;
  font-style: italic;
  margin-bottom: 5px;
}

</style>



// WEBPACK FOOTER //
// GroupUserSearch.vue?7e2c2c2d